import { TrippleToggle } from "@src/components/atoms";
import { SectionContainer } from "@src/pages/sharedSections";
import HorizontalLayout from "@src/components/cards/HorizontalLayout";

const SelfReportInfoCard = ({ showPredictions, dc }) => {
  return (
    <SectionContainer
      bgColor={"primary-100"}
      className={"border-1 border-primary-500 p-2"}
      borderColor={"primary"}
      shadow={false}
      textColor={"primary"}
      paddingX={4}
    >
      <div className="text-left py-2">
        {dc(
          `captain__self_report__data_priority${showPredictions ? "_predicted" : ""}`,
        )}
      </div>

      <HorizontalLayout ratio={[1, 1, 1]}>
        <div className="flex-1 text-center">
          <TrippleToggle
            className="align-middle"
            disabled={true}
            neutral={false}
            checked={false}
            backgroundColorLeft="gray"
          />
          {dc(
            `captain__self_report__legend_not_achieved${showPredictions ? "_predicted" : ""}`,
          )}
        </div>
        <div className="flex-1 text-center">
          <TrippleToggle
            className="align-middle"
            disabled={true}
            neutral={true}
            checked={false}
            backgroundColorCenter="primary"
          />
          {dc(
            `captain__self_report__legend_to_be_reported${showPredictions ? "_predicted" : ""}`,
          )}
        </div>
        <div className="flex-1 text-center">
          <TrippleToggle
            className="align-middle"
            disabled={true}
            neutral={false}
            checked={true}
            backgroundColorRight="primary-600"
          />
          {dc(
            `captain__self_report__legend_achieved${showPredictions ? "_predicted" : ""}`,
          )}
        </div>
      </HorizontalLayout>
    </SectionContainer>
  );
};

export default SelfReportInfoCard;
